import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    fullWidth: {
        width: '100%',
        height: '30px',
        borderRadius: '20px',
        textAlign: 'center',
        background: '#D7D7D7',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('lg')]: {
            height: '20px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '14px',
        },
    },
    textLevelCurrent: {
        zIndex: 1,
        color: '#FFFFFF',
        fontSize: themeCommon.fontSize22px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize11px,
        },
    },
    levelWidth: {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '30px',
        // props for width
        width: props => props.levelText && props.levelText * 20 + '%',
        // width: '100px',
        background: `${themeCommon.bg_btn}`,
        borderRadius: '20px',
        [theme.breakpoints.down('lg')]: {
            height: '20px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '14px',
        },
    },
    currentLevel: {
        position: 'absolute',
        // props for left
        left: props => props.levelText && props.levelText * 20 + '%',
        // left: '100px',
        top: '50%',
    },
    textLevel: {
        transform: 'translate(-50%, -50%)',
        color: '#FFFFFF',
        zIndex: '3',
        fontSize: themeCommon.fontSize22px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize15px,
        },
    },
    bgTextLevel: {
        transform: 'translate(-50%, -50%) rotate(45deg)',
        width: '40px',
        height: '40px',
        borderRadius: '5px',
        transformOrigin: 'center',
        background: `${themeCommon.bg_btn}`,
        zIndex: '2',
        [theme.breakpoints.down('lg')]: {
            width: '23px',
            height: '23px',
            borderRadius: '3px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '17px',
            height: '17px',
            borderRadius: '1px',
        },
    },
    borderTextLevel: {
        transform: 'translate(-50%, -50%) rotate(45deg)',
        width: '50px',
        height: '50px',
        borderRadius: '5px',
        transformOrigin: 'center',
        background: `#FFFFFF`,
        zIndex: '1',
        [theme.breakpoints.down('lg')]: {
            width: '28px',
            height: '28px',
            borderRadius: '3px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '22px',
            height: '22px',
            borderRadius: '1px',
        },
    },
    maxLevel: {
        position: 'absolute',
        // props for left
        left: '100%',
        top: '50%',
        zIndex: '1',
    },
    textMaxLevel: {
        color: themeCommon.bg_btn,
        zIndex: '2',
    },
    bgMaxTextLevel: {
        background: '#FFFFFF',
    },
}), {
    name: 'ProgressBarHeaderHeadContainer',
    index: 1,
})

export default useStyles;